import axios from 'axios';
import Account from './main-views/Account';
import { MdChevronLeft } from 'react-icons/md';
import LoginView from './views/LoginView';
import ContactUs from './views/ContactUs';
import Notifications from './main-views/Notifications';
import Home from './main-views/Home';
import PostItem from './views/PostItem';
import ViewItem from './views/ViewItem';
import ViewSale from './views/ViewSale';
import ViewOrder from './views/ViewOrder';
import MyOrders from './main-views/MyOrders';
import MySales from './main-views/MySales';
import MyRevenues from './main-views/MyRevenues';
import MyWithdrawalRequests from './main-views/MyWithdrawalRequests';
import ViewWithdrawalRequest from './views/ViewWithdrawalRequest';
import ViewRevenue from './views/ViewRevenue';
import ViewWithdrawal from './views/ViewWithdrawal';
import MyWithdrawals from './main-views/MyWithdrawals';
import MyRevenueHistory from './main-views/MyRevenueHistoryLanding';
import Shop from './main-views/Shop';
import CreatePost from './views/CreatePost';
import { STR_ACCOUNT, STR_DONATIONS, STR_MENU_SHOP, STR_NOTIFICATIONS } from './Strings';
import DonationForm from './views/DonationForm';
import Pastors from './main-views/Pastors';
import Members from './main-views/Members';
import Penalties from './main-views/Penalties';
import Loans from './main-views/Loans';
import Contributions from './main-views/Contributions';

export const BASE_API = 'https://watuapi.werenium.com/api/';

export const CDN_URL = 'https://faith.werenium.com/cdn/';

export const WEB_SOCKET_URL = "wss://faithapi.werenium.com/";


export function getMainView(app) {
  if (app.navItem === 'home' || !app.navItem) {
    return <Home />;
  } else if (app.navItem === 'notifications') {
    return <Notifications />;
  } else if (app.navItem === 'account') {
    return <Account />;
  } else if (app.navItem === 'members') {
    return <Members />;
  } else if (app.navItem === 'contributions') {
    return <Contributions />;
  } else if (app.navItem === 'loans') {
    return <Loans />;
  } else if (app.navItem === 'penalties') {
    return <Penalties />;
  } 
  return null;
}


export function getViewerView(app) {
  if (
    app.navSubItem === 'login' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LoginView />;
  } else if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'create-post' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CreatePost />;
  } else if (
    app.navSubItem === 'donation-form' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <DonationForm />;
  } else if (
    app.navSubItem === 'item' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewItem uuid={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'post-item' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PostItem />;
  }


  return null;
}

export function getSideViewerView(app) {
  
  if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } 
  
  return null;
}

export function getBottomViewerView(app) {

  if (
    app.navSubItem === 'contact_us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } 

  return null;
}

export function getTopBarTitle(app) {
  if (app.navItem === 'account') {
    return (<span className='font-light'>{STR_ACCOUNT[app.language]}</span>);
  } else if (app.navItem === 'shop') {
    return (<span className='font-light'>{STR_MENU_SHOP[app.language]}</span>);
  } else if (app.navItem === 'donations') {
    return (<span className='font-light'>{STR_DONATIONS[app.language]}</span>);
  } else if (app.navItem === 'notifications') {
    return (<span className='font-light'>{STR_NOTIFICATIONS[app.language]}</span>);
  } 

  return (<span className='font-light'>FAITH<span className='font-semi-bold'>Connect</span></span>);
}


export function getInlineLoader() {
  return (
    <div className="Loader" aria-hidden="true">
      <span className="Loader-stroke Loader-stroke-one"></span>
      <span className="Loader-stroke Loader-stroke-two"></span>
      <span className="Loader-dot Loader-dot-one"></span>
      <span className="Loader-dot Loader-dot-two"></span>
      <span className="Loader-core"></span>
    </div>
  )
}

export function remove255(input = '') {
  if (input && input.startsWith('255')) {
    return '0' + input.slice(3);
  }
  return input;
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function formatDateForInput(timestamp) {
  // Convert timestamp from seconds to milliseconds
  const date = new Date(timestamp * 1000);

  // Extract year, month, and day with padding for month and day if needed
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  // Format the date as YYYY-MM-DD for input type="date"
  return `${year}-${month}-${day}`;
}

export function isSameWeek(date) {
  const today = new Date();
  const currentWeekDay = today.getDay();
  const firstDayOfWeek = new Date(today.setDate(today.getDate() - currentWeekDay)); // Sunday
  const lastDayOfWeek = new Date(today.setDate(today.getDate() + 6)); // Saturday

  return date >= firstDayOfWeek && date <= lastDayOfWeek;
};

export function isSameMonth(date) {
  const today = new Date();
  return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      // .. setup form data
      let formData = new FormData();
      formData.append('language', getCookie('language'));

      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      // Retry mechanism: try up to 3 times
      let attempt = 0;
      const maxRetries = 3;

      const makeRequest = async () => {
        try {
          const response = await axios.post(BASE_API + url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          console.log(url, response.data);
          resolve(response.data); // Successfully resolve with response data
        } catch (error) {
          attempt++;
          if (attempt < maxRetries) {
            console.log(`Attempt ${attempt} failed. Retrying...`);
            makeRequest(); // Retry the request
          } else {
            resolve({
              status: 0,
              msg: "Network Connection Error after 3 attempts",
            }); // Resolve after 3 failed attempts
          }
        }
      };

      // Start the request attempts
      makeRequest();
    });
  });
}

export function generateRandomString(length = 6) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('userId');
    let userToken = getCookie('userToken');

    resolve({
      userId,
      userToken
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  cname = 'faith-user-'+cname;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();

  // Get the current domain from window.location.hostname
  let domain = window.location.hostname;

  // Set domainPart only if it's not 'localhost'
  let domainPart = domain !== 'localhost' ? `;domain=${domain}` : '';

  // Add the SameSite attribute to restrict cross-origin access (Strict or Lax as per your needs)
  let sameSite = ";SameSite=Strict";

  // Add the Secure flag for HTTPS connections
  let secureFlag = window.location.protocol === 'https:' ? ";Secure" : '';

  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + domainPart + sameSite + secureFlag;
}


export function getCookie(cname) {
  cname = 'faith-user-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function formatMoney(x) {
  x = Number(x);

  // Check if the number has a decimal part
  let hasDecimal = x % 1 !== 0;

  // Format based on whether there's a decimal
  x = hasDecimal ? x.toFixed(2) : x.toString();

  // Split into integer and decimal parts
  var parts = x.split(".");
  
  // Add comma separation to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number, with decimals only if present
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function strtotime(dateString) {
  const date = new Date(dateString);

  // Check if time part is missing in the date string
  if (dateString.trim().length <= 10) { // If length is 10, it's just 'YYYY-MM-DD'
    date.setHours(23, 59, 59, 999); // Set time to the end of the day (23:59:59.999)
  }

  return Math.floor(date.getTime() / 1000);
}
